import { FC } from 'react';

interface EmptyStateProps {
  icon?: string;
  title: string;
  /** O PRÓXIMO PASSO, não só "sem dados" — o módulo abre vazio na primeira vez. */
  hint: string;
}

const EmptyState: FC<EmptyStateProps> = ({ icon = 'inbox', title, hint }) => (
  <div
    data-testid="seop-empty-state"
    className="rounded-xl border border-dashed border-theme-border bg-surface-card p-8 text-center"
  >
    <span className="material-symbols-outlined text-3xl text-content-muted">{icon}</span>
    <h3 className="mt-2 font-semibold text-content-primary">{title}</h3>
    <p className="mt-1 text-sm text-content-muted">{hint}</p>
  </div>
);

export default EmptyState;
